import { MapPin, Calendar } from "lucide-react";
import "@/styles/ProjectCard.css";

const ProjectCard = ({ project, index }) => {
  return (
    <div 
      className="project-card fade-in-up" 
      style={{ animationDelay: `${index * 0.1}s` }}
      data-testid={`project-card-${index}`}
    >
      <div className="project-image-container">
        <img 
          src={project.image_url} 
          alt={project.title} 
          className="project-image"
          data-testid={`project-image-${index}`}
        />
        <div className="project-overlay">
          <span className="project-category" data-testid={`project-category-${index}`}>
            {project.category}
          </span>
        </div>
      </div>
      
      <div className="project-content">
        <h3 className="project-title" data-testid={`project-title-${index}`}>{project.title}</h3>
        <p className="project-description" data-testid={`project-description-${index}`}>
          {project.description}
        </p>
        
        <div className="project-meta">
          {project.location && (
            <div className="meta-item" data-testid={`project-location-${index}`}>
              <MapPin size={16} />
              <span>{project.location}</span>
            </div>
          )}
          {project.year && (
            <div className="meta-item" data-testid={`project-year-${index}`}>
              <Calendar size={16} />
              <span>{project.year}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;